import React, { Component } from "react";
import Data from "../Data/data.js";
import { Link } from "react-router-dom";

class ShowCase extends Component {
  constructor(props) {
    super(props);
    const { match } = this.props;
    const id = match.params.id;
    this.state = {
      id
    };
  }

  render() {
    const greaterThan = ">";
    const smallerThan = "<";
    const Filteredelement = Data.filter(element => {
      return element.index === Number(this.state.id);
    });
    const fixedElement=Filteredelement[0];
    return (
      <main className="show_case">
        <div className="show_casediv">
          <section className="case_text">
            <div>
              <h1>
                <span>{smallerThan}</span> {fixedElement.title}{" "}
                <span>{greaterThan}</span>
              </h1>
            </div>
            <ul className="case_details">
              <li>
                <h5>Role :</h5>
                <p>{fixedElement.role}</p>
              </li>
              <li>
                <h5>live here:</h5>
                <a
                  href={fixedElement.link}
                  onMouseEnter={() => this.props.runOnEnter()}
                  onMouseLeave={() => {
                    this.props.runOnLeave();
                  }}
                >
                  {fixedElement.link}
                </a>
              </li>
              <li>
                <h5>Stack :</h5>
                <p>{fixedElement.stack.join(", ")}</p>
              </li>
            </ul>
            <h4>{fixedElement.summary}</h4>
          </section>
          <section className="case_img">
            {fixedElement.images.map((item,index )=> {
              console.log(item);
              return <img src={item} key={index} alt="" />;
            })}
          </section>
          <section className="case_next">
            {Number(this.state.id) === Data.length - 1 ? (
              <Link
                href={`/`}
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
              >
                Home ->
              </Link>
            ) : (
              <Link
                href={`/work/${fixedElement.index + 1}`}
                onMouseEnter={() => this.props.runOnEnter()}
                onMouseLeave={() => {
                  this.props.runOnLeave();
                }}
              >
                next project ->
              </Link>
            )}
          </section>
        </div>
      </main>
    );
  }
}
export default ShowCase;
